// 기본 Judge 선택. 엔드포인트가 설정돼 있으면 실제 서버 프록시(httpJudge),
// 아니면 개발용 mockJudge. verdict가 이걸 기본값으로 쓴다.

import { Capacitor } from "@capacitor/core";
import type { Judge } from "./judge";
import { mockJudge } from "./judge";
import { httpJudge } from "./httpJudge";

// Vite 환경변수. .env(.production)에 VITE_JUDGE_ENDPOINT=https://bwek.app/api/judge 설정 시 실제 호출.
const RAW = (typeof import.meta !== "undefined" && import.meta.env?.VITE_JUDGE_ENDPOINT) || "";

// 네이티브(capacitor://localhost)는 절대 URL이 필요. 웹은 같은 오리진 상대경로(/api/judge)로 —
// 어느 도메인에서 서빙되든(bwek.app SSL 발급 전 bwek-f1c83.web.app 포함) Hosting rewrite로 바로 동작.
const ENDPOINT = RAW
  ? Capacitor.isNativePlatform()
    ? RAW
    : RAW.replace(/^https?:\/\/[^/]+/, "")
  : "";

export const defaultJudge: Judge = ENDPOINT ? httpJudge(ENDPOINT) : mockJudge;

export const usingRealJudge = Boolean(ENDPOINT);
